class PLPModal extends HTMLElement {
  constructor() {
    super();

    const _this = this;

    this.modalToggles = this.querySelectorAll('[data-modal-toggle]');
    this.linkButtons = this.querySelectorAll('[data-link-button]');

    this.toggleModalHotspots();

    this.modalToggles.forEach((button) => {
      button.addEventListener('click', _this.toggleModal.bind(_this));
    });

    document.addEventListener('keyup', (event) => {

      if (event.key === 'Escape') {
        _this.classList.remove('is--active');
        document.querySelector('body').classList.remove('no-scroll');
      }
    });

  }

  toggleModal() {

    console.log('toggleModal');
    this.classList.toggle('is--active');

    if (this.classList.contains('is--active')) {
      this.querySelector('[data-placement-wrap]').focus();
      document.querySelector('body').classList.add('no-scroll');
    }

    if (!this.classList.contains('is--active')) {
      document.activeElement.blur();
      document.querySelector('body').classList.remove('no-scroll');
    }
  }

  toggleModalHotspots() {

    const _this = this;

    this.linkButtons.forEach((button) => {
      button.addEventListener('mouseover', (e) => {
        e.stopPropagation();

        if (window.innerWidth < 1024) return;

        const index = e.target.dataset.linkButton;
        _this.querySelector(`.plp-placement-modal #placementButton_${index}`).classList.add('is--active');
      });

      button.addEventListener('mouseleave', (e) => {
        e.stopPropagation();

        if (window.innerWidth < 1024) return;

        const index = e.target.dataset.linkButton;
        _this.querySelector(`.plp-placement-modal #placementButton_${index}`).classList.remove('is--active');
      });
    });
  }
}

customElements.define('plp-placement', PLPModal);